import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from '../../state/action-sources';

export const CancelPreauthDialogActions = createActionGroup({
    source: ActionSource.CANCEL_PREAUTH_DIALOG,
    events: {
        'Cancel Preauth From Row Clicked': props<{
            transactionId: string;
            amountMinor: number;
            terminalEpi: string | undefined;
        }>(),
        'Cancel Preauth Confirmed': emptyProps(),
        'Cancel Preauth Dismissed': emptyProps(),
        // Requirement: the release answers as soon as its leg exists and settles in
        // the background, so "success" means SENT. `knownLegIds` is what lets the
        // job tell this attempt's leg from an earlier one when it settles.
        'Cancel Preauth Success': props<{ transactionId: string; knownLegIds: string[] }>(),
        'Cancel Preauth Error': props<{ error: Error }>(),
    },
});
